import { createAction } from '@reduxjs/toolkit'
import { call, takeEvery } from 'redux-saga/effects'

import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { MasterSetPlanRegion, Select } from '../../lib/toolBoxes/2D'

export const clearMasterSetTemporaryPathAction = createAction('clearTemporaryPath')

export function* handleClearingTemporaryPathsIfCoordinatesAreCleared() {
    const manager: PaperManager | null = yield call(managers.get2DManager)

    if (!manager) return

    const [masterSetRegionTool, selectTool]: [MasterSetPlanRegion, Select] = yield call(manager.getTools, [
        MasterSetPlanRegion.NAME,
        Select.NAME,
    ])

    yield call(selectTool.exitSelectMode)

    yield call(masterSetRegionTool.clearTemporaryPath)
}

export function* watchForClearingMasterSetCreationCoordsUpdate() {
    yield takeEvery(clearMasterSetTemporaryPathAction, handleClearingTemporaryPathsIfCoordinatesAreCleared)
}
